import moment from "moment";

export const dateFormat = 'YYYY-MM-DD';

export function toISO(value?: string | Date): string | undefined {
    return value ? moment(value).format(`${dateFormat}THH:mm`) : undefined;
}
